import { render, staticRenderFns } from "./WorkspaceNodeConnectionTabs.vue?vue&type=template&id=2ca84310&scoped=true"
import script from "./WorkspaceNodeConnectionTabs.vue?vue&type=script&lang=js"
export * from "./WorkspaceNodeConnectionTabs.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceNodeConnectionTabs.vue?vue&type=style&index=0&id=2ca84310&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca84310",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca84310')) {
      api.createRecord('2ca84310', component.options)
    } else {
      api.reload('2ca84310', component.options)
    }
    module.hot.accept("./WorkspaceNodeConnectionTabs.vue?vue&type=template&id=2ca84310&scoped=true", function () {
      api.rerender('2ca84310', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceNodeConnectionTabs.vue"
export default component.exports